import { render, staticRenderFns } from "./OrderStatus.vue?vue&type=template&id=23f1671e&scoped=true&"
import script from "./OrderStatus.vue?vue&type=script&lang=ts&"
export * from "./OrderStatus.vue?vue&type=script&lang=ts&"
import style0 from "./OrderStatus.vue?vue&type=style&index=0&id=23f1671e&prod&lang=scss&"
import style1 from "./OrderStatus.vue?vue&type=style&index=1&id=23f1671e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f1671e",
  null
  
)

export default component.exports